import { render, staticRenderFns } from "./TipoEmbalagem.vue?vue&type=template&id=20c47274&"
import script from "./TipoEmbalagem.vue?vue&type=script&lang=js&"
export * from "./TipoEmbalagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports